module.exports = __webpack_public_path__ + "cd455783/img/share-icon.0f8a11b4.svg";